<template>
  <el-dialog
    :show-close="!isRequired"
    :before-close="cancel"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :model-value="showDialog"
    :top="top"
    @opened="opened"
    @open="open"
  >
    <template #header>
      <span class="el-dialog__title">
        <slot name="title">Dialog</slot>
      </span>
    </template>

    <customized-form
      v-loading="loading"
      element-loading-custom-class="custom-spinner-class"
      @submit="submitForm"
    >
      <slot />

      <div class="dialog-submit-button-group">
        <p-button
          v-if="isAvailableSubmit"
          type="purple"
          round
          native-type="submit"
          :disabled="isDisabled || !showDialog"
        >
          <slot name="submit-button">
            Submit
          </slot>
        </p-button>

        <slot name="additional-buttons-1" />

        <slot name="additional-buttons-2" />

        <p-button
          v-if="!isRequired"
          type="yellow"
          round
          @click="cancel"
        >
          <slot name="cancel-button">
            Cancel
          </slot>
        </p-button>
      </div>
    </customized-form>
  </el-dialog>
</template>

<script setup lang="ts">
defineProps({
  showDialog: {
    type: Boolean,
    default: false,
  },

  isDisabled: {
    type: Boolean,
    default: false,
  },

  isRequired: {
    type: Boolean,
    default: false,
  },

  isAvailableSubmit: {
    type: Boolean,
    default: true,
  },

  loading: {
    type: Boolean,
    default: false,
  },

  top: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['open', 'opened', 'submit', 'cancel']);

// triggers when the Dialog opens
const open = () => {
  emit('open');
};

// triggers when the Dialog opening animation ends
const opened = () => {
  emit('opened');
};

// triggers when form is submitted
const submitForm = (event: any) => {
  emit('submit', event);
};

// triggers when dialog is closed
const cancel = () => {
  emit('cancel');
};
</script>
